import { ColumnDefResolved } from "@tanstack/react-table"
import { Command } from "cmdk"

import { faIcon } from "@utils/faIcon"
import generateRandomKey from "@utils/generateRandomKey"

import { Popover } from "@molecules"
import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"

import { BottomSheetItemBase } from "@organisms/BottomSheet/BottomSheetItem/BottomSheetItem"
import useTable from "@organisms/Table/Table.context"

import styles from "./BottomSheetAddColumns.module.scss"
import { BottomSheetAddColumnsProps } from "./BottomSheetAddColumns.types"

export default function BottomSheetAddColumns<T>(props: BottomSheetAddColumnsProps) {
    const { isVisible } = props

    const { updateColumnVisibility, invisibleColumns } = useTable<T>()

    const handleColumnVisibilityChange = (column: ColumnDefResolved<T>) => {
        updateColumnVisibility(column.accessorKey as string, true)
    }

    const noColumns = invisibleColumns.length === 0

    return (
        <>
            <Popover.Section animationType="fade">
                <PopoverHeader.Root>
                    <PopoverHeader.BackButton backDestination="columns" aria-label="Back" />
                    <PopoverHeader.Title title="Add Columns" />
                </PopoverHeader.Root>
            </Popover.Section>
            <Popover.Section animationType="slide">
                <Popover.Body>
                    <Command>
                        <Command.List>
                            <Command.Empty>
                                <div className={styles.noColumns}>
                                    <div className={styles.noColumnsText}>
                                        No columns {noColumns ? "to add" : "found"}
                                    </div>
                                </div>
                            </Command.Empty>
                            <Command.Group className={styles.items}>
                                {invisibleColumns.map((column) => (
                                    <Command.Item key={generateRandomKey()} value={column.header}>
                                        <BottomSheetItemBase
                                            icon={faIcon({ name: "plus", style: "regular" })}
                                            isTabbable={isVisible}
                                            label={column.header as string}
                                            onClick={() => handleColumnVisibilityChange(column)}
                                        />
                                    </Command.Item>
                                ))}
                            </Command.Group>
                        </Command.List>
                    </Command>
                </Popover.Body>
            </Popover.Section>
        </>
    )
}
